<template>
  <div id="container">
    <el-menu class="header" :default-active="$route.path" mode="horizontal" @select="handleSelect">
      <el-menu-item index="/main/saleRecord">销售记录</el-menu-item>
      <el-menu-item index="/main/menuManage">菜单管理</el-menu-item>
<!--      <el-menu-item index="/main/faceAdmin">人脸管理</el-menu-item>-->
      <!--<el-menu-item index="/main/classDishManage">碗碟管理</el-menu-item>-->
      <el-menu-item index="/main/summary" v-if="userinfo.username === '阿斯利康'">流量统计</el-menu-item>
      <span class="avatar-box">
        <el-dropdown @command="logout" trigger="click">
          <span class="el-dropdown-link">
            <el-button type="text">
              {{userinfo.username}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>注销</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </span>
    </el-menu>
<!--    <el-dialog-->
<!--      title="安全提示"-->
<!--      :visible.sync="

"-->
<!--      width="30%">-->
<!--      <h4>您已经 <span class="danger-text">{{date_subtraction}}</span>天未更新密码, 为了保证账号安全, 请更新您的密码!</h4>-->
<!--      <el-form ref="form" :rules="rules" :model="form" label-width="80px">-->
<!--        <el-form-item label="旧密码" prop="oldPassword">-->
<!--          <el-input v-model="form.oldPassword" placeholder="请输入旧密码"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="新密码" prop="newPassword">-->
<!--          <el-input v-model="form.newPassword" placeholder="请输入新密码"></el-input>-->
<!--        </el-form-item>-->
<!--      </el-form>-->
<!--      <span slot="footer" class="dialog-footer">-->
<!--        <el-button @click="secureDialogShow = false">取 消</el-button>-->
<!--        <el-button type="primary" @click="comfirmEdit">确 定</el-button>-->
<!--      </span>-->
<!--    </el-dialog>-->
    <router-view></router-view>
  </div>
</template>
<script type="">

import { apiPasswordUpdate, apiPwdCheckUpdate } from '@/api'
export default {
  name: 'admin',
  data () {
    const checkNewPwd = (rule, value, callback) => {
      console.log(value, this.oldPassword)
      if (value === this.form.oldPassword) {
        callback(new Error('新旧密码不能相同'))
      } else {
        // this.$refs['form'].validateField('checkPass');
        callback()
      }
    }
    return {
      secureDialogShow: false,
      date_subtraction: 0,
      form: {
        oldPassword: '',
        newPassword: ''
      },
      rules: {
        oldPassword: [
          { required: true, message: '请输入旧密码!', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码!', trigger: 'blur' },
          { validator: checkNewPwd, trigger: 'blur' }
        ]
      },
      logoutButtonToggle: false,
      activeIndex: '/main/menuManage'
    }
  },
  mounted () {
    console.log('asdasdsadas')
    this.$store.dispatch('getCanteenList').then((res) => {
      console.log(res)
      this.$router.push({
        path: '/main/menuManage'
      })
    }).catch((e) => {

    })
    // this.checkUpdate()
  },
  methods: {
    // resetForm(form) {
    //   this.$refs[form].resetFields();
    // },
    // async checkUpdate () {
    //   try {
    //     let { date_subtraction } = await apiPwdCheckUpdate(this.userinfo.api_key)
    //     if (date_subtraction > 90) {
    //       this.secureDialogShow = true
    //       this.date_subtraction = date_subtraction
    //     }
    //   } catch (e) {
    //     // this.$message.error('密码更新日期查询失败' + e.message)
    //   }
    // },
    handleSelect (path) {
      this.$router.push({ path: path })
    },
    comfirmEdit () {
      this.$refs['form'].validate(async valid => {
        if (valid) {
          // alert('submit!');
          // this.$message.warning('修改成功')
          try {
            const apiKey = await apiPasswordUpdate({
              old_password: this.form.oldPassword,
              new_password: this.form.newPassword,
              user_name: this.userinfo.username,
              api_key: this.userinfo.api_key
            })
            // this.api_key = apiKey
            this.$store.dispatch('setUserinfo', {
              api_key: apiKey,
              username: this.userinfo.username,
              eatery_id: this.userinfo.eatery_id
            })
            this.$message.success('修改成功')
          } catch (e) {
            this.$message.error('修改失败, ' + e.message)
          }
        } else {
          // console.log('error submit!!');
          this.$message.error('请检查表单')
          return false
        }
      })
    },
    logout () {
      this.$store.dispatch('clearUserinfo')
      this.$router.push('/')
    }
  },
  computed: {
    userinfo () {
      return this.$store.getters.userinfo()
    },
    username () {
      return this.userinfo.username
    },
    api_key () {
      return this.userinfo.api_key
    },
    dev () {
      return process.env.NODE_ENV !== 'production'
    }
  }
}
</script>
<style lang="scss" type="">
#container {
  margin: 0 2%;
}
.header {
  position: relative;
}
.danger-text {
  color: #dd6161;
}
.avatar-box {
  position: absolute;
  display: inline-block;
  right: 0;
  height: 100%;
  line-height: 60px;
}
</style>
